import { useMotionValue } from 'framer-motion';
import { useCallback, useEffect, useRef, useState } from 'react';
const useWindowInnerHeight = (({ motionValue = false }) => {
    const windowHeight = useMotionValue(0);
    const [windowHeightState, setWindowHeightState] = useState(0);
    const rulerElement = useRef(null);
    const calculateDimension = useCallback(() => {
        var _a, _b, _c, _d;
        if (motionValue) {
            windowHeight.set((_b = (_a = rulerElement.current) === null || _a === void 0 ? void 0 : _a.offsetHeight) !== null && _b !== void 0 ? _b : 0);
        }
        else {
            setWindowHeightState((_d = (_c = rulerElement.current) === null || _c === void 0 ? void 0 : _c.offsetHeight) !== null && _d !== void 0 ? _d : 0);
        }
    }, [motionValue, windowHeight]);
    useEffect(() => {
        let resizeObserver = null;
        // create a fake element to measure the height of the window
        // while Safari on iOS / iPadOS adjusts its address bar height
        rulerElement.current = document.createElement('div');
        rulerElement.current.style.position = 'fixed';
        rulerElement.current.style.height = '100vh';
        rulerElement.current.style.width = '0';
        rulerElement.current.style.top = '0';
        rulerElement.current.style.zIndex = '-10000';
        rulerElement.current.style.opacity = '0.001';
        // needed to ensure DOM calculation is happening
        document.documentElement.appendChild(rulerElement.current);
        resizeObserver = new ResizeObserver(calculateDimension);
        resizeObserver.observe(rulerElement.current);
        return () => {
            resizeObserver === null || resizeObserver === void 0 ? void 0 : resizeObserver.disconnect();
            if (rulerElement.current && document.documentElement.contains(rulerElement.current)) {
                document.documentElement.removeChild(rulerElement.current);
            }
            rulerElement.current = null;
        };
    }, [calculateDimension]);
    return motionValue ? windowHeight : windowHeightState;
});
export default useWindowInnerHeight;
